import { random } from 'mathjs';

/** *
 * This interface is for user defaultBackgroundColor properties in user
 * It will used in getBackgroundColor()
 *
 * Teb Yuma
 * 2024-08-28

* interface UserType {
* defaultBackgroundColor: string;
* }
*/

// 랜덤 색상
const getRandomNumber = (length: number) => Math.floor(random(0, length));
const RANDOM_COLORS = [
  '#fb6262',
  '#d16443d4',
  '#4d9fd6',
  '#40bca7',
  '#9db82f',
  '#76a0d6',
  '#a967d4',
  '#696481',
  '#4c438d',
  '#fe7947',
];
export const randomColor = RANDOM_COLORS[getRandomNumber(RANDOM_COLORS.length)];

export const getBackgroundColor = (user: any): string => {
  if (user.defaultBackgroundColor) {
    return user.defaultBackgroundColor;
  }

  return user?.profile?.defaultBackgroundColor;
};
